import React from 'react';
import PropTypes from 'prop-types';
import tinycolor from 'tinycolor2';

function ColoredCell({ value, min = 0, max = 15, children }) {
  let style = null;

  if (value) {
    const calculatedHue = ((max - min - (value - min)) / (max - min)) * 233;
    const tinyColorInstance = tinycolor(`hsl(${calculatedHue}, 100%, 50%)`);
    const backgroundColor = tinyColorInstance.toHexString();
    const color = tinycolor.isReadable(backgroundColor, '#FFF', { level: 'AA', size: 'small' }) ? '#FFF' : '#000';

    style = { backgroundColor, color };
  }

  return children(style);
}

ColoredCell.propTypes = {
  value: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  children: PropTypes.func.isRequired,
};

export default React.memo(ColoredCell);
